<script>
    import Fa from 'svelte-fa'
    import { faCog, faMinusSquare, faPlusSquare, faSquare, faUsers } from '@fortawesome/free-solid-svg-icons'
    import { Route, Link, Router } from 'yrv'
    import Content from '../_common/content.svelte'
    import StockHome from './stock-home.svelte'
    import StockIn from './stock-in.svelte'
    import StockOut from './stock-out.svelte'
    import StockConfig from './stock-config.svelte'
    import Ztab from '../_common/z/ztab.svelte'

    let tabs = []
    tabs.push({ title: 'Estoque', url: '/stock/home' })
    tabs.push({ title: 'Entradas', url: '/stock/in' })
    tabs.push({ title: 'Saídas', url: '/stock/out' })
    if (window.store.token.permissions.stock.configs.write) {
        tabs.push({ title: 'Configurações', url: '/stock/config' })
    }
</script>

<Content>
    <div class="root-content">
        <Ztab class="h-space" {tabs}></Ztab>
        <div class="body">
            <Router>
                <Route path="/home">
                    <StockHome />
                </Route>
                <Route path="/in">
                    <StockIn />
                </Route>
                <Route path="/out">
                    <StockOut />
                </Route>
                <Route path="/config">
                    <StockConfig></StockConfig>
                </Route>
            </Router>
        </div>
    </div>
</Content>
